import structuredClone from '@ungap/structured-clone'

export default function initStructuredClonePolyfill () {
  if (!window.structuredClone) {
    window.structuredClone = structuredClone as typeof window.structuredClone
  }
}
